import React from "react";
import LandingPage from "./LandingPage";
import Testimonials from "./Testimonials";
//import Challenges from "./Challenges";
import LearnMore from "./LearnMore";
import Operation from "./Operation";

type Props = {};

const LandingPageWrapper = (props: Props) => {
  return (
    <div>
      <div>
        <LandingPage />
      </div>
      <div>
        <Operation />
      </div>
      <div>
        <Testimonials />
      </div>
      <div>{/* <Challenges /> */}</div>

      <div>
        <LearnMore />
      </div>
    </div>
  );
};

export default LandingPageWrapper;
